import { withInstall } from '@ll-plus/utils'

import CopyText from './src/copy-text.vue'

export const LlCopyText = withInstall(CopyText)

export * from './src/copy-text'

declare module 'vue' {
  export interface GlobalComponents {
    LlCopyText: typeof CopyText
  }
}
